import { defineComponent, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { SettingTable, SettingTableRow, Selector, ToggleInput, ImageDescription } from '@hems/component';
import { DateHelper, Helper } from '@hems/util';
import { STORM_COVER_BUTTON, STORM_MESSAGE } from '@hems/util/src/constant';
export default defineComponent({
    name: 'StormCoverSetting',
    components: {
        SettingTable,
        SettingTableRow,
        ToggleInput,
        Selector,
        ImageDescription,
    },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        editable: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue'],
    async setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore();
        const stormCoverSetting = reactive({
            stormCoverMode: props.modelValue?.storm_cover_flag ?? 0,
            batteryCharge: props.modelValue?.storm_cover_charge_type ?? null,
            stormData: store.state.storm,
        });
        const selectorOptionsState = reactive({
            batterySource: [],
        });
        const BATTERY_SOURCE = [
            { code: '0', name: 'Charge from Solar' },
            {
                code: '1',
                name: 'Charge from Solar & Grid',
                description: STORM_MESSAGE.CHARGING_FROM_GRID,
            },
        ];
        selectorOptionsState.batterySource = Helper.addSelectorOptionAtFirst(Helper.codeNamesToSelectorOptions(BATTERY_SOURCE, t), { text: t('common.select'), value: null });
        function onChangeStormCoverSetting() {
            emit('update:modelValue', {
                storm_cover_flag: stormCoverSetting.stormCoverMode,
                storm_cover_charge_type: stormCoverSetting.batteryCharge,
            });
        }
        function convertToStormCoverDate(date) {
            return DateHelper.getLocalDate(date, { isTime: true, isSecond: false, needUtcConvert: true });
        }
        return {
            stormCoverSetting,
            selectorOptionsState,
            STORM_COVER_BUTTON,
            convertToStormCoverDate,
            onChangeStormCoverSetting,
            STORM_MESSAGE,
        };
    },
});
